import { DataSource, EntityTarget, ObjectLiteral, QueryRunner, Repository } from 'typeorm';

enum DBConnectionType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

interface QueryBuilderBaseOptions {
  dataSource?: DataSource;
  queryRunner?: QueryRunner;
  connectionType?: DBConnectionType;
}

interface RepositoryQueryBuilderOptions<T extends ObjectLiteral> extends QueryBuilderBaseOptions {
  repository: Repository<T>;
  alias?: string;
  entity?: never;
}

interface EntityQueryBuilderOptions<T extends ObjectLiteral> extends QueryBuilderBaseOptions {
  entity: EntityTarget<T>;
  alias?: string;
  repository?: never;
}

interface RawQueryBuilderOptions extends QueryBuilderBaseOptions {
  repository?: never;
  entity?: never;
  alias?: never;
}

type QueryBuilderOptions<T extends ObjectLiteral = any> =
  | RepositoryQueryBuilderOptions<T>
  | EntityQueryBuilderOptions<T>
  | RawQueryBuilderOptions;

export { DBConnectionType };
export type { QueryBuilderOptions, QueryBuilderOptions as QueryRunnerOptions, RawQueryBuilderOptions };
